import React from "react";
const FileStatusTableRow = (rowData, maxPercentage) => {
  const percentage = ((rowData.percentage / maxPercentage) * 100).toFixed(0);
  const styleMyBar = {
    borderRadius: "5px",
    width: `${percentage}%`,
    opacity: 0.5,
  };

  if (percentage < 5) {
    styleMyBar.backgroundColor = "rgba(161, 196, 233, 0.5)"; // Blue color with opacity
  } else if (percentage < 20) {
    styleMyBar.backgroundColor = "rgba(161, 233, 161, 0.5)"; // Green color with opacity
  } else {
    // Calculate the intensity based on the percentage value
    const intensity = Math.floor(255 - (percentage - 20) * 6.375); // Adjust the multiplier (6.375) to control intensity
    styleMyBar.backgroundColor = `rgba(${intensity}, 0, 0, 0.5)`; // Red color with intensity and opacity
  }

  const verticalLine = {
    borderRightWidth: "2px",
  };
  return (
    <>
      <tr>
        <td>{rowData.fileStatus}</td>

        <td style={verticalLine}>
          {rowData.fileCount} ({percentage}%)
        </td>

        <td>
          <div style={styleMyBar}>&nbsp;</div>
        </td>
      </tr>
    </>
  );
};

export default FileStatusTableRow;
